<template>
  <div @mouseover="mouseOverSnackBar" @mouseleave="mouseLeaveSnackBar">
    <v-snackbar
      v-model="showSnackBar"
      :color="snackBarColor"
      content-class="white--text"
      :timeout="localTimeOut"
    >
      {{ message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="black"
          text
          v-bind="attrs"
          @click="executeAction"
          :disabled="loading"
        >
          <v-progress-circular
            v-if="loading"
            indeterminate
            size="28"
            width="3"
            color="white"
          ></v-progress-circular>
          <div v-if="!loading">
            {{ buttonTitle }}
          </div>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    //success | error | info
    snackType: {
      type: String,
      required: true,
    },
    colour: String,
    timeout: {
      type: String,
      default() {
        return "5000";
      },
    },
    //Able to override button title, only shown on error
    buttonTitle: {
      type: String,
      default: "Close",
    },
    //If enable, it emits 'eCustomBtnOperation' which a function can be attached to
    enableCustomBtnOperation: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data() {
    return {
      loading: false,
      localTimeOut: this.timeout,
    };
  },
  computed: {
    showSnackBar: {
      get() {
        return this.isShow;
      },
      set() {
        //Need to update {showSnackBar} value on caller page
        this.$emit("eReset");
      },
    },
    snackBarColor() {
      if (this.colour) return this.colour;
      if (this.snackType.toLowerCase() === "success") return "rgb(3, 201, 169)";
      if (this.snackType.toLowerCase() === "error") return "rgb(255, 76, 48)";
      return "rgb(105,105,105)";
    },
  },
  methods: {
    buttonAction() {
      return this.enableCustomBtnOperation
        ? this.customBtnOperation()
        : this.closeSnackBar();
    },
    async executeAction() {
      try {
        this.loading = true;
        this.buttonAction();
        this.closeSnackBar();
        this.loading = false;
      } catch (err) {
        this.closeSnackBar();
        this.loading = false;
        this.$logger.error(err);
      }
    },
    closeSnackBar() {
      this.showSnackBar = false;
    },
    mouseOverSnackBar() {
      this.localTimeOut = -1;
    },
    mouseLeaveSnackBar() {
      this.localTimeOut = this.timeout;
    },
    customBtnOperation() {
      this.$emit("eCustomBtnOperation");
    },
  },
};
</script>
